import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDealer } from "@/contexts";
import DealerDialog from "@/components/organisms/DealerDialog";
import * as S from "./styles";

const Channels: React.FC = () => {
  const navigate = useNavigate();
  const { dealer, coopInfo } = useDealer();
  const [isNavigating, setIsNavigating] = useState(false);
  const [existingOrder, setExistingOrder] = useState<any>(null);

  useEffect(() => {
    console.log('Channels component - Current dealer state:', dealer);
    if (!dealer) {
      console.log('Channels component - No dealer found, redirecting to login');
      navigate("/login");
    }
  }, [dealer, navigate]);

  const handleChannelSelect = (channel?: string) => {
    if (isNavigating) return; // Prevent multiple navigations
    
    console.log('Channels component - Selected channel:', channel);
    if (channel) {
      setIsNavigating(true);
      console.log('Channels component - Navigating to:', channel);
      navigate(channel);
    }
  };

  return (
    <S.ChannelsPage>
      <DealerDialog
        dealer={dealer}
        open={true}
        onClose={handleChannelSelect}
      />
    </S.ChannelsPage>
  );
};

export default Channels; 